module.exports = __webpack_public_path__ + "img/main.43db3b4b.jpg";